

import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class DumpTemplateBody extends Vue {
    @Prop() dumpValue!: string[];
}
